module.exports = __webpack_public_path__ + "i18n/zh-CN.25dc9bcf6c822f06abc215d4a9469de8.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1549
// module chunks = 60